/**
 * Created with IntelliJ IDEA.
 * User: raml
 * Date: 3/20/13
 * Time: 10:46 AM
 */
define(function (require) {
    "use strict";

    var LE = require("app"),
        LEConfig = require("assets/config/le-env-conf"),
        CP_CONST = require("connection-const"),
        template = require("connection-templates/chatTab/chatWindowLayout.tmpl"),
        domUtilities = require("infra-util/DomUtilities"),
        Loader = require("ui/loader/Loader"),
        Button = require("ui/button/Button"),
        ChatWindowLayout = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        var logger = LEConnection.logger;

        ChatWindowLayout = Marionette.Layout.extend({

            template: template,
            className: "connection-panel-chat-frame",
            regions: {
                chatConnecting: ".chat-window-connecting-region",
                chatContent: ".chat-window-content-region",
                chatInput: ".chat-window-input-region"

            },

            ui: {
                chatContent: ".connection-panel-chat-content",
                agentTyping: ".chat-window-agent-typing",
                typingIndicator: ".chat-window-agent-typing .agent-typing-indicator",
                resizeContainer: ".chat-window-resize-container",
                headerText: ".header-text",
                chatCloseButton : ".chat-close-button",
                // backButton: ".back-button",
                messageWindowWrapper:  ".message-window-wrapper",
                chatWindowWrapper: ".chat-window-wrapper"
            },
            triggers: {
                "click .chat-close-button": "chat:close:button:click",
                "click .conversation-back-button": "conversation:back:button:click"
            },

            initialize: function (options) {

                this._chatVent = options.chatVent;
                this._resizeContainerOrgBottom = 0;
                this._agentName = "";
                this._messagingAgent = options.model;
                this._loader = null;

                this._bindEvents();
            },

            resetOnChatEnded: function () {
                this._setResizeContainerBottom(this._resizeContainerOrgBottom);
            },

            toggleConnectingFlag: function (show) {
                this.$el.toggleClass("connecting-showing", show);
                if(show){
                    this.ui.headerText.text("");
                }
            },

            closeChatContent: function(){
                this.chatContent.close();
            },

            _loadUnifiedWindowInMessagingFrame: function (options) {
                logger.debug("ChatWindowLayout._loadUnifiedWindowInMessagingFrame");
                var leCdnDomain = this._buildUnifiedWindowURL();
                var reqURL = 'https://' + leCdnDomain + '/index.html?lpUnifiedWindowConfig=' + options.unifiedWindowCfg;
                this._getMessagingFrame(options.contactModel).prop("src", reqURL);
                this._chatVent.trigger("cpChatUI::layout:chat:show");
            },

            _buildUnifiedWindowURL: function () {
                var unifiedWindowConfig = LEConfig.connectionPanelSettings.unifiedWindow || {};
                var isConfigSet = unifiedWindowConfig.hasOwnProperty("baseURL") && !_.isEmpty(unifiedWindowConfig.baseURL) && unifiedWindowConfig.hasOwnProperty("version");
                if (isConfigSet) {
                    var url = unifiedWindowConfig.baseURL + "/le_unified_window";
                    url = unifiedWindowConfig.version ? url + "/" + unifiedWindowConfig.version : url;
                    return url;
                }
                return LE.urlResolver.getConfigValue("leCdnDomain") + "/le_unified_window";
            },

            _loadUnifiedWindowInChatFrame: function (encodedUnifiedWindowConfig) {
                logger.debug("ChatWindowLayout._loadUnifiedWindowInChatFrame");
                var leCdnDomain = LE.urlResolver.getConfigValue("leCdnDomain");
                var reqURL = 'https://' + leCdnDomain + '/le_unified_window/index.html?lpUnifiedWindowConfig=' + encodedUnifiedWindowConfig;
                this.ui.chatFrame.prop("src", reqURL);
                this._displayChatFrame();
            },

            showLoader: function(){
                if (!this._loader) {
                    this._loader = new Loader({
                        permutation: Loader.PERMUTATION.L,
                        el: this.el
                    });
                }
                if (!this._loader.getIsRendered()) {
                    this._loader.render();
                }
            },

            closeLoader: function(){
                if (this._loader){
                    this._loader.close();
                }
            },

            _bindEvents: function () {
                this.listenTo(this._chatVent, "cpChatUI::agentTyping:update", this._onAgentTyping);
                this.listenTo(this._chatVent, "chatConnection:chat:ended", this._onChatEnded);
                this.listenTo(this._chatVent, "cpChatUI:input:resize", this._onInputResize);
                this.listenTo(this._messagingAgent, "sync", this._onMessagingAgentChanged);
                this.listenTo(this._chatVent, "chatConnection:state", this._onChatting);
                this.listenTo(this._chatVent, "click:chatGroup", this._onClickChatGroup);
                this.listenTo(this._chatVent, "remove:messaging:frames", this._removeAllMessagingFrames);
            },

            _onChatting: function(event) {
                var chatState = event.state || "unknown";
                if (chatState === CP_CONST.CHAT_STATES.CHATTING || chatState ===  CP_CONST.CHAT_STATES.RESUMING) {
                    this.ui.headerText.text(this._agentName);
                }
            },

            _onClickChatGroup: function (displayName) {
                    this._agentName = displayName || "";
            },

            _onMessagingAgentChanged: function (model) {
                if (model && !this._getMessagingFrame(model).hasClass("hide")) {
                    this.ui.headerText.text(model.get("nickname"));
                }
            },

            _displayChatFrame: function (options,chatState) {
                var messageFrames = this.ui.messageWindowWrapper.children('iframe');
                if (messageFrames.length) {
                    messageFrames.addClass("hide");
                }
                if (chatState !== CP_CONST.CHAT_STATES.CHATTING){
                    this.ui.headerText.text("");
                } else {
                    this.ui.headerText.text(this._agentName);
                }
                this.ui.chatWindowWrapper.removeClass("hide");
                this.ui.chatCloseButton.removeClass("hide");
            },

            _displayMessagingFrame: function(model){
                this.ui.chatCloseButton.addClass("hide");
                this.ui.chatWindowWrapper.addClass("hide");
                this._toggleMessagingFramesVisibility(model);
                this.ui.headerText.text(model.isPSGContact() ?  this._messagingAgent.get("nickname") : model.get('displayName'));
            },

            _removeAllMessagingFrames: function(){
                while(this.ui.messageWindowWrapper[0].firstChild){
                    this.ui.messageWindowWrapper[0].removeChild(this.ui.messageWindowWrapper[0].firstChild);
                }
            },

            _getMessagingFrame: function(model) {
                // here we are using this method for 2 different models once for the AgentMessagingModel and once for the ChatContactModel
                // -> dirty but since i really dont know the whole flow, i will just fix it here instead of changing it somewhere else
                var uniqueName = (model && _.isFunction(model.getSkillName)) ? model.getSkillName() : model.get('nickname');
                if (!(this.ui.messageWindowWrapper.children('#'+uniqueName).length)){
                    //we dont have this frame yet, so lets create one
                    this.ui.messageWindowWrapper.append('<iframe class=\"connection-panel-messaging-frame hide\" id=\"' + uniqueName  +'\"></iframe>\n');
                }
                return this.ui.messageWindowWrapper.children('#' + uniqueName);
            },

            _toggleMessagingFramesVisibility: function(model){
                var modelFrame = this._getMessagingFrame(model);
                var otherFrames = this.ui.messageWindowWrapper.children('iframe').not('#' + model.getSkillName());

                if (modelFrame.length) {
                    modelFrame.first().removeClass('hide');
                    if($(modelFrame.first()[0]) && $(modelFrame.first()[0])[0] && $(modelFrame.first()[0])[0].contentWindow){
                        $(modelFrame.first()[0])[0].contentWindow.focus();
                    }
                }

                if (otherFrames.length) {
                    otherFrames.addClass("hide");
                }
            },

            _bindIFrameEvents: function () {
                this.listenTo(this._chatVent, "load:unifiedWindowInMessagingFrame", this._loadUnifiedWindowInMessagingFrame, this);
                this.listenTo(this._chatVent, "load:unifiedWindowInChatFrame", this._loadUnifiedWindowInChatFrame, this);
                this.listenTo(this._chatVent, "cpChatUI:display:chatFrame", this._displayChatFrame, this);
                this.listenTo(this._chatVent, "cpChatUI:display:messagingFrame", this._displayMessagingFrame, this);
            },

            onRender: function () {
                setTimeout(_.bind(function () { // By setting timeout we ensure that the asynchronous code is done after current thread code is completed and this UI component is attached to the DOM, so we can get CSS bottom property
                    this._resizeContainerOrgBottom = domUtilities.getPixelCount(this.ui.resizeContainer.css("bottom"));
                    this._resizeContainerBottom = this._resizeContainerOrgBottom;
                }, this), 1);
                this._bindIFrameEvents();
            },

            _onInputResize: function (options) {

                if (options.delta) {
                    this._setResizeContainerBottom((this._resizeContainerBottom + options.delta));
                }
            },

            _setResizeContainerBottom: function (bottom) {
                this._resizeContainerBottom = bottom;
                this.ui.resizeContainer.css("bottom", bottom);
            },

            _onChatEnded: function () {
                this._onAgentTyping({typing: false}); //stop showing agent typing for ended chats
            },

            _onAgentTyping: function (data) {

                logger.debug("received agent typing event - ", "ChatWindowLayout._onAgentTyping", data);

                if (this.getIsRendered()) {

                    if (data.typing && this._agentName !== data.name) {
                        this.ui.typingIndicator.attr("title", (LE.translator.translate("LEConnection.chat.agentIsTypingTooltip").replace("{0}", data.name)));
                    }

                    this.ui.typingIndicator.toggleClass("hide", !data.typing);
                }
            }
        });
    });
    return ChatWindowLayout;
});
